import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-project-actions-list',
  templateUrl: 'project-actions-list.component.html',
  styleUrls: ['project-actions-list.component.scss'],
})
export class ProjectActionsListComponent implements OnDestroy {
  private _unsubscribe$ = new Subject();

  constructor() {}

  ngOnDestroy(): void {
    this._unsubscribe$.next(undefined);
    this._unsubscribe$.complete();
  }
}
